import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbService {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  buildBreadCrumb(): string[] {
    let route = this.activatedRoute.root;
    const breadcrumbs = [];

    while (!!route) {
      let label = this.getBreadCrumbLabel(route);
      const path = this.getBreadCrumbUrl(route);

      // If the route is a Param such as ':id', exclude
      const lastRoutePart = path.split('/').pop();
      const isParamRoute = lastRoutePart.startsWith(':');
      if (isParamRoute && !!route.snapshot) {
        const paramName = lastRoutePart.split(':')[1];
        label = route.snapshot.params[paramName];
      }

      const breadcrumb: string = label;
      if (breadcrumb) {
        breadcrumbs.push(breadcrumb);
      }

      if (route.firstChild) {
        route = route.firstChild;
      } else {
        route = null;
      }
    }

    return breadcrumbs;
  }

  private getBreadCrumbLabel(route: ActivatedRoute): string {
    return (route.routeConfig && route.routeConfig.data && route.routeConfig.data.breadcrumb) || '';
  }

  private getBreadCrumbUrl(route: ActivatedRoute): string {
    return (route.routeConfig && route.routeConfig.data && route.routeConfig.path) || '';
  }
}
